
// const baseUrl = "http://localhost:5000/api/v1.0/";
const baseUrl = process.env.REACT_APP_API_URL;
//const imageUrl = "https://c706a43d45fa.ngrok.io";

export const environment = {
  production: true,
  baseUrl: `${baseUrl}`
};

export const supportMail = "GQ-Support@aptean.com";

// --- OAuth authorize: search-mcp Claude connector per-user login (spec 003) ---
// /oauth-authorize recognizes exactly ONE client_id and an EXACT-MATCH
// redirect_uri allow-list (FR-3). This client-side check is a fast-fail UX
// nicety only — the backend (do=gqoauth.mint_code) is the real security
// boundary and MUST re-validate both.
// PLACEHOLDERS: confirm before deploy. redirect_uri is search-mcp's OWN OAuth
// callback (fastmcp OAuthProxy default path /auth/callback) — NOT a Claude URL —
// and must exactly match what search-mcp is configured with AND the allow-list
// the backend enforces (GqOAuthDispatcher::REDIRECT_URI_ALLOWLIST). The OAuth
// client_secret is intentionally NOT here: it lives only on the backend and in
// search-mcp's server config, never in the browser.
// Override per-environment via REACT_APP_OAUTH_* if preferred.
export const oauthConfig = {
  clientId: process.env.REACT_APP_OAUTH_CLIENT_ID || "search-mcp",
  redirectUriAllowList: (
    process.env.REACT_APP_OAUTH_REDIRECT_URIS ||
    ""
  )
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean),
};
export const usBaseUrl = "https://www.uspto.gov/web/patents/classification/";
export const ipcBaseUrl = "https://wipo.int/ipcpub/?notion=scheme&version=20130101&symbol=";
export const ipcrBaseUrl = "https://wipo.int/ipcpub/?notion=scheme&version=20130101&symbol=";
export const cpcBaseUrl = "https://worldwide.espacenet.com/classification#!/CPC=";